import { ErrorType } from '../../errors/errors.types.js';
import useAlertStore from '../../store/alerts.js';

const showPlanUpgradePrompt = (upgradePromptOptions) => useAlertStore.getState().addAlert({
  ...upgradePromptOptions,
  type: "upgrade_prompt"
});
const showPlanUpgradePromptWithErrorCode = (error) => {
  const errorType = typeof error === "string" ? error : typeof error === "object" && "detail" in error ? error.detail : typeof error === "object" && "message" in error ? error.message : typeof error === "object" && "type" in error ? error.type : void 0;
  switch (errorType) {
    case ErrorType.EXCEEDS_STORAGE_LIMIT:
      showPlanUpgradePrompt({
        planEntitlement: "maxTotalStorageSizeMB"
      });
      return true;
    case ErrorType.EXCEEDS_CREDIT_LIMIT:
      showPlanUpgradePrompt({
        planEntitlement: "creditCentsMonthly"
      });
      return true;
    case ErrorType.EXCEEDS_CHATBOT_LIMIT:
      showPlanUpgradePrompt({
        planEntitlement: "creditCentsMonthly"
      });
      return true;
    default:
      return false;
  }
};

export { showPlanUpgradePrompt, showPlanUpgradePromptWithErrorCode };
//# sourceMappingURL=showPlanUpgradePrompt.js.map
